/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Import_As_EventsInputs */



/**
* | output |
* | --- |
* | "Import as Event Group" |
*
* @param {Ocr_Import_As_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_import_as_events = /** @type {((inputs?: Ocr_Import_As_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Import_As_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer en tant que groupe d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Als Ereignisgruppe importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa come gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импортировать как группу событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar como grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入为事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループとしてインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह के रूप में आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar como Grupo de Eventos")
	return /** @type {LocalizedString} */ ("Import as Event Group")
});